import { render, staticRenderFns } from "./SysBoxTable.vue?vue&type=template&id=d1742bf8&scoped=true"
import script from "./SysBoxTable.vue?vue&type=script&lang=js"
export * from "./SysBoxTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1742bf8",
  null
  
)

export default component.exports